import React, { useContext } from 'react';
import styles from './ReportCardInfo.module.scss';
import { ReportConfig, ReportValue } from '../../../Models';
import { GeneralInformation } from './GeneralInformation/GeneralInformation';
import { ItemList } from './ItemList/ItemList';
import { StateConfigContext } from '../../../Context/StateConfigContext';
import { CadInformation } from './CadInformation/CadInformation';

export interface ReportCardInfoProps {
  className?: string;
  report: ReportValue;
}

export const ReportCardInfo = ({
  className = '',
  report
}: ReportCardInfoProps): React.ReactElement<ReportCardInfoProps> => {
  const stateConfig = useContext(StateConfigContext)
    .stateConfig as ReportConfig;

  return (
    <div className={`${styles.reportCardInfo} ${className}`}>
      <div className={styles.content}>
        <GeneralInformation
          data={report.general_information}
          tags={report.tags}
        />
      </div>

      <div className={styles.content}>
        {report.cad_rms && <CadInformation data={report.cad_rms} />}

        {stateConfig.citizen &&
          report.citizens &&
          report.citizens.length > 0 && (
            <ItemList
              items={report.citizens}
              title="Citizens Information"
              itemsName="citizen"
              config={stateConfig.citizen}
            />
          )}

        {stateConfig.officer &&
          report.officers &&
          report.officers.length > 0 && (
            <ItemList
              items={report.officers}
              title="Officers Involved"
              itemsName="officer"
              config={stateConfig.officer}
            />
          )}
      </div>
    </div>
  );
};
